module.exports = {
    "appName": "Application",
    "baseURL": "https://webapi.accountprogress.com",
    "env": "PROD",
    "oldWebsite": "https://oldversion.accountprogress.com:82/{0}/CiwLogin.aspx"
}